import React, { useEffect, useState } from "react";
import { Box, Text, Flex, Heading } from "@chakra-ui/react";
import HerVestTable from "../components/Table/HervestTable";
import moment from "moment";
import { obscureText } from "../services/utils/helpersFunc";
import { getAllDirectDebits } from "../services/axios";
import ModalLayout from "../components/Layout/ModalLayout";
import HervestSearch from "../components/Search/HervestSearch";
import SectionLayout from "../components/RequestDocument/SectionLayout";
import { motion } from "framer-motion";

const MotionBox = motion(Box);

const columns = [
  {
    name: "S/N",
    key: "id",
  },
  {
    name: "Account Name",
    key: "account_name",
  },
  {
    name: "DD Type",
    key: "card_type",
  },
  {
    name: "Bank",
    key: "bank",
  },
  {
    name: "Customer Email",
    key: "email",
  },
  {
    name: "Status",
    key: "status",
  },
  {
    name: "Activated on",
    key: "created_at",
  },
];

function DirectDebitPage() {
  const [directDebits, setDirectDebits] = useState([]);
  const [loading, setLoading] = useState(false);
  const [meta, setMeta] = useState({});
  const [openDetails, setOpenDetails] = useState(false);
  const [selectedDetails, setSelectedDetails] = useState({});

  let filters = {};
  const getDirectDebits = async () => {
    setLoading(true);
    const res = await getAllDirectDebits(filters);
    setLoading(false);
    if (res) {
      const mappedData = res.data.data.map((data, index) => {
        return {
          ...data,
          account_name: data.account_name,
          card_type: data.card_type,
          bank: data.bank,
          email: data?.user?.email,
          active: data.active,
          status: data.active ? "Active" : "Pending",
          created_at: moment(data.created_at).format("DD/MM/YYYY"),
        };
      });
      setDirectDebits(mappedData);
      setMeta(res?.data?.meta);
    }
  };

  useEffect(() => {
    getDirectDebits();
    // eslint-disable-next-line
  }, []);

  const detailSections = [
    {
      title: "Mandate Information",
      items: [
        { label: "BANK", value: selectedDetails.bank },
        { label: "ACCOUNT NAME", value: selectedDetails.account_name },
        { label: "AUTHORIZATION CODE", value: obscureText(selectedDetails.authorization_code) },
        { label: "SIGNATURE", value: obscureText(selectedDetails.signature) },
      ]
    },
    {
      title: "Technical Details",
      items: [
        { label: "AUTHORIZING BANK", value: selectedDetails.bank },
        { label: "CHANNEL", value: selectedDetails.channel },
        { label: "DD EXPIRING MONTH", value: selectedDetails.exp_month },
        { label: "DD EXPIRING YEAR", value: selectedDetails.exp_year },
      ]
    },
    {
      title: "Customer Details",
      items: [
        { label: "CUSTOMER EMAIL", value: selectedDetails?.user?.email },
        { label: "CUSTOMER PHONE NUMBER", value: selectedDetails?.user?.phone },
      ]
    }
  ];

  return (
    <Box
      bg="gray.50"
      p={["20px 16px", "20px 24px", "24px 32px"]}
      minH="100vh"
      w="100%"
    >
      <MotionBox
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        mb={8}
      >
        <Flex justify="space-between" align="center" flexWrap="wrap" gap={4}>
          <Box>
            <Heading size="md" color="brand.900" mb={1}>Direct Debit Mandates</Heading>
            <Text fontSize="sm" color="gray.600">Manage and view all direct debit authorizations</Text>
          </Box>
          <Box w={["100%", "300px"]}>
            <HervestSearch
              searchHandler={(e) => {
                filters = { searchQuery: e.target.value };
                getDirectDebits(filters);
              }}
            />
          </Box>
        </Flex>
      </MotionBox>

      <HerVestTable
        onClickHandler={(item) => {
          setSelectedDetails(item);
          setOpenDetails(true);
        }}
        meta={meta}
        data={directDebits}
        columns={columns}
        loading={loading}
      />

      <ModalLayout
        setIsOpen={setOpenDetails}
        title="Direct Debit Details"
        hideFooter={true}
        isOpen={openDetails}
      >
        <Box py={4}>
          {detailSections.map((section, idx) => (
            <SectionLayout
              key={idx}
              title={section.title}
              items={section.items}
            />
          ))}
        </Box>
      </ModalLayout>
    </Box>
  );
}

export default DirectDebitPage;
